import { render } from "./AdminLayoutv2.vue?vue&type=template&id=891dec76&scoped=true"
import script from "./AdminLayoutv2.vue?vue&type=script&lang=js"
export * from "./AdminLayoutv2.vue?vue&type=script&lang=js"

import "./AdminLayoutv2.vue?vue&type=style&index=0&id=891dec76&lang=css"
import "./AdminLayoutv2.vue?vue&type=style&index=1&id=891dec76&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891dec76"]])

export default __exports__